import React, { Component } from 'react';
import { Progress } from 'reactstrap';
import DistributionCard from './DistributionCard';
import HashfileCard from './HashfileCard';
import { loadFile, hashData } from '../functions/hashing';
import { generateNewDistribution } from '../functions/supression';

class CompareHash extends Component {
  constructor() {
    super();
    this.state = {
      distributionFile: null,
      hashfile: null,
      hashfileCase: 'upper',
      outputFile: null,
      outputFileLink: null,
      inProgress: false,
      error: null,
    };
  }

  uploadDistributionFile = (event) => {
    this.setState({ distributionFile: event.target.files[0] });
  };

  uploadHashfile = (event) => {
    this.setState({ hashfile: event.target.files[0] });
  };

  setHashfileCase = (event) => {
    this.setState({ hashfileCase: event.target.value });
  };

  runSuppression = () => {
    const { distributionFile, hashfile, hashfileCase } = this.state;
    const isUpper = hashfileCase === 'upper';
    document.title = 'Comparison in Progress';
    return this.setState({ inProgress: true, error: null }, () => loadFile(distributionFile)
      .then(({ data }) => {
        const hashedDistributionData = hashData(data, isUpper, false);
        if (hashedDistributionData && hashedDistributionData.length) {
          return generateNewDistribution(hashedDistributionData, hashfile);
        }
        throw new Error('No emails found in distribution file');
      })
      .then((outputFile) => {
        document.title = 'Comparison Complete';
        return this.setState({
          outputFile,
          outputFileLink: URL.createObjectURL(outputFile),
          inProgress: false,
        });
      })
      .catch((error) => {
        document.title = 'Error While Comparing Lists';
        this.setState({ error: error.toString(), inProgress: false });
      }));
  };

  render() {
    const {
      distributionFile,
      hashfile,
      hashfileCase,
      outputFile,
      outputFileLink,
      inProgress,
      error,
    } = this.state;
    return (
      <>
        <h2 className="text-primary text-center">Compare Hash</h2>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6 mb-3">
                <DistributionCard
                  distributionFile={distributionFile}
                  uploadDistributionFile={this.uploadDistributionFile}
                />
              </div>
              <div className="col-md-6 mb-3">
                <HashfileCard
                  hashfile={hashfile}
                  hashfileCase={hashfileCase}
                  uploadHashfile={this.uploadHashfile}
                  setHashfileCase={this.setHashfileCase}
                />
              </div>
            </div>
            {inProgress ? (
              <div>
                <h5 className="text-center">In Progress</h5>
                <Progress animated value={100} />
              </div>
            ) : (
              <>
                <button
                  className="btn btn-primary d-block ml-auto"
                  onClick={this.runSuppression}
                  disabled={!hashfile || !distributionFile}
                  type="button"
                >
                  Compare Lists
                </button>
                {error && (
                <div className="alert alert-danger mt-3">
                  {error}
                </div>
                )}
                {outputFileLink && (
                  <a
                    href={outputFileLink}
                    download={outputFile.name}
                    className="btn btn-block btn-success mt-3"
                  >
                    Download File
                  </a>
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default CompareHash;
